import { Col, Row } from 'antd';
import React from 'react';

interface Props {
  numberName?: string;
  channelName?: string;
}

export function ConnectedChannelsItem({ numberName, channelName }: Props) {
  return (
    <div style={{ backgroundColor: '#e8f9fe', padding: 12 }}>
      <Row>
        <Col span={12} style={{ lineHeight: '32px', fontWeight: 'bold' }}>
          {numberName || '-'}
        </Col>
        <Col span={12} style={{ lineHeight: '32px' }}>
          {channelName || ''}
        </Col>
      </Row>
    </div>
  );
}
